import { useEffect, useRef } from "react"
import { getCable } from "../../../shared/api/cable"

export const useChatRoomSocket = ({ chatType, chatId, onMessage, onReadStatus, onPresence }) => {
  const handlersRef = useRef({ onMessage, onReadStatus, onPresence })
  handlersRef.current = { onMessage, onReadStatus, onPresence }

  useEffect(() => {
    if (!chatId) return

    const cable = getCable()
    const subscription = cable.subscriptions.create(
      { channel: "ChatRoomChannel", chat_type: chatType, chat_id: chatId },
      {
        received(data) {
          const { onMessage, onReadStatus, onPresence } = handlersRef.current
          if (data.type === "new_message") onMessage?.(data)
          if (data.type === "read_status") onReadStatus?.(data)
          if (data.type === "presence") onPresence?.(data)
        },
      }
    )

    return () => subscription.unsubscribe()
  }, [chatType, chatId])
}

export default useChatRoomSocket
